import { AlertTriangle } from 'lucide-react';

interface StockUrgencyProps {
  stock: number;
}

export const StockUrgency = ({ stock }: StockUrgencyProps) => {
  if (stock <= 0 || stock > 5) return null;

  return (
    <div className="flex items-center gap-1.5 text-sm font-medium text-destructive animate-pulse">
      <AlertTriangle className="h-4 w-4" />
      <span>Only {stock} left in stock!</span>
    </div>
  );
};
